import { createReducer } from '@reduxjs/toolkit';
import { fetchClaimResponseDeadlineExtensionsThunk } from './claim-response-deadline-extensions.thunk';
import { ClaimResponseDeadlineExtensionsState } from './claim-response-deadline-extensions.types';

const initialState: ClaimResponseDeadlineExtensionsState = {
  byClaimId: {},
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(fetchClaimResponseDeadlineExtensionsThunk.fulfilled, (state, action) => {
      state.byClaimId[action.meta.arg.claimId] = { extensions: action.payload, hasFetched: true, hasFailed: false };
    })
    .addCase(fetchClaimResponseDeadlineExtensionsThunk.rejected, (state, action) => {
      // Marked as fetched so the card does not retry on every render, and as failed so admin offers a retry instead of
      // showing no extensions. Any extensions already loaded stay.
      const claimId = action.meta.arg.claimId;
      const current = state.byClaimId[claimId];
      state.byClaimId[claimId] = { extensions: current ? current.extensions : [], hasFetched: true, hasFailed: true };
    });
});
